/**
 * /admin/external-auditors — External auditor invitations (route shell).
 * Screen impl in `./external-auditors-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/external-auditors')({
  component: lazyRouteComponent(
    () => import('./external-auditors-screen'),
    'AdminExternalAuditors',
  ),
});
